let dirPath = 'static/games/page002_game0';
let dirAudio = 'games/page002_game0/audio/';

let configGame = {
  removeInCorrects: true,
  correctBlock: true,
  bruteForce: false,
  autoCheckAllCorrect: true,
  rulesGame: {
    // itemsConfig: { shuffle: true },
    otherProperty: {
      sounds: [{ src: dirAudio + 'click.mp3', id: 'mouseup' }],
    },
    items: [
      {
        itemsConfig: { shuffle: true },
        idGroup: 'left',
        idItem: 'con1',
        items: [{ idGroup: 'right', idItem: 'con1', correct: [{ idGroup: 'left', idItem: 'con1' }] }],
      },
      {
        itemsConfig: { shuffle: true },
        idGroup: 'left',
        idItem: 'con2',
        items: [{ idGroup: 'right', idItem: 'con2', correct: [{ idGroup: 'left', idItem: 'con2' }] }],
      },
      {
        itemsConfig: { shuffle: true },
        idGroup: 'left',
        idItem: 'con3',
        items: [{ idGroup: 'right', idItem: 'con3', correct: [{ idGroup: 'left', idItem: 'con3' }] }],
      },
      // {
      //   itemsConfig: { shuffle: true },
      //   idGroup: 'right',
      //   idItem: 'con1',
      //   items: [{ idGroup: 'left', idItem: 'con1', correct: [{ idGroup: 'right', idItem: 'con1' }] }],
      // },
      // {
      //   itemsConfig: { shuffle: true },
      //   idGroup: 'right',
      //   idItem: 'con2',
      //   items: [{ idGroup: 'left', idItem: 'con2', correct: [{ idGroup: 'right', idItem: 'con2' }] }],
      // },
      // {
      //   itemsConfig: { shuffle: true },
      //   idGroup: 'right',
      //   idItem: 'con3',
      //   items: [{ idGroup: 'left', idItem: 'con3', correct: [{ idGroup: 'right', idItem: 'con3' }] }],
      // },
    ],
  },
  layout: {
    itemsConfig: {
      background: {},
    },
    otherProperty: {
      // lines: {
      //   good: {
      //     hideLine: true,
      //   },
      //   connect: {
      //     color: '#239ad6',
      //     hideLine: true,
      //   },
      //   select: {
      //     color: '#239ad6',
      //     hideLine: true,
      //   },
      // },
      points: {
        pointMouse: {
          color: 'rgba(255,255,255,0.01)',
          rad: 10,
          alwaysShow: true,
        },
        itemsConfig: {
          alwaysShow: true,
          color: 'rgba(255,255,255,0.01)',
          positions: { rad: 10 },
        },
      },
      /*    lines: {

            connect: { color: 'black' }
          } */
    },
    groups: [
      {
        idGroup: 'left',
        positions: {
          autoFit: true,
          type: 'absolute',
          fixTab: [
            { x: 360, y: 435 },
            { x: 690, y: 350 },
            { x: 50, y: 300 },
          ],
        },
        itemsConfig: {
          positions: { pos: { width: 340, height: 460 } },
          background: {
            color: 'rgba(255,255,255,0.01)',
            text: { font: 'Linotype', size: '50px', offset: { y: 6, x: 100 } },
          },
        },
        otherProperty: {
          points: {
            itemsConfig: { positions: { rad: 8 }, registrationPoint: { setTo: 'left' } },
            items: [{ id: 'p01', positions: { pos: { setTo: 'right' } } }],
          },
        },
        items: [
          {
            id: 'con1',
            positions: { pos: { width: 310, height: 600 } },
            background: { color: 'rgba(255,255,255,0.01)' },
            otherProperty: {
              points: { itemsConfig: { positions: { offset: { x: -45 } } } },
              audio: 'a01',
              lines: {
                good: {
                  hideLine: true,
                  color: '#008000',
                },
                connect: {
                  color: '#ff0000',
                  hideLine: true,
                },
                select: {
                  color: '#ff0000',
                  hideLine: true,
                },
              },
            },
          },
          {
            id: 'con2',
            background: { color: 'rgba(255,255,255,0.01)' },
            otherProperty: {
              points: { itemsConfig: { positions: { offset: { x: -47 } } } },
              audio: 'a02',
              lines: {
                good: {
                  hideLine: true,
                  color: '#008000',
                },
                connect: {
                  color: '#ff0000',
                  hideLine: true,
                },
                select: {
                  color: '#ff0000',
                  hideLine: true,
                },
              },
            },
          },
          {
            id: 'con3',
            background: { color: 'rgba(255,255,255,0.01)' },
            otherProperty: {
              points: { itemsConfig: { positions: { offset: { x: -31 } } } },
              audio: 'a03',
              lines: {
                good: {
                  hideLine: true,
                  color: '#008000',
                },
                connect: {
                  color: '#ff0000',
                  hideLine: true,
                },
                select: {
                  color: '#ff0000',
                  hideLine: true,
                },
              },
            },
          },
        ],
      },
      {
        idGroup: 'right',
        positions: {
          autoFit: true,
          type: 'absolute',
          fixTab: [
            { x: 1560, y: 150 },
            { x: 1300, y: 400 },
            { x: 1560, y: 600 },
          ],
        },
        itemsConfig: {
          positions: { pos: { width: 205, height: 300 } },
          background: { image: { pos: { y: 0 } } },
        },
        otherProperty: {
          // lines: {
          //   good: {
          //     hideLine: true,
          //   },
          //   connect: {
          //     color: '#239ad6',
          //     hideLine: true,
          //   },
          //   select: {
          //     color: '#239ad6',
          //     hideLine: true,
          //   },
          // },
          points: {
            itemsConfig: { positions: { rad: 8 }, registrationPoint: { setTo: 'center' } },
            items: [{ id: 'p01', positions: { pos: { setTo: 'center' } } }],
          },
        },
        items: [
          {
            id: 'con1',
            positions: { pos: { width: 180, height: 330 } },
            background: { color: 'rgba(255,255,255,0.01)', image: { src: dirPath + '/img/dusty_g.png' } },
            otherProperty: {
              // points: { itemsConfig: { positions: { offset: { x: 100 } } } },
              lines: {
                good: {
                  hideLine: true,
                  color: '#008000',
                },
                connect: {
                  color: '#ff0000',
                  hideLine: true,
                },
                select: {
                  color: '#ff0000',
                  hideLine: true,
                },
              },
            },
          },
          {
            id: 'con2',
            positions: { pos: { width: 190, height: 280 } },
            background: {
              color: 'rgba(255,255,255,0.01)',
              image: { src: dirPath + '/img/tom_g.png' },
            },
            otherProperty: {
              // points: { itemsConfig: { positions: { offset: { x: 110 } } } },
              lines: {
                good: {
                  hideLine: true,
                  color: '#008000',
                },
                connect: {
                  color: '#ff0000',
                  hideLine: true,
                },
                select: {
                  color: '#ff0000',
                  hideLine: true,
                },
              },
            },
          },
          {
            id: 'con3',
            positions: { pos: { width: 205, height: 300 } },
            background: {
              color: 'rgba(255,255,255,0.01)',
              image: { src: dirPath + '/img/lisa_g.png' },
            },
            otherProperty: {
              // points: { itemsConfig: { positions: { offset: { x: 100 } } } },
              lines: {
                good: {
                  hideLine: true,
                  color: '#008000',
                },
                connect: {
                  color: '#ff0000',
                  hideLine: true,
                },
                select: {
                  color: '#ff0000',
                  hideLine: true,
                },
              },
            },
          },
        ],
      },
    ],
  },
};
let dataConfig = {
  mixinEngine: 'connect',
  blockCheck: true,
  fullscreen: true,
  mainImage: {
    imagePath: dirPath + '/img/bcg.webp',
    pos: {
      y: 0,
      x: 0,
    },
  },
  mbAudioItemData: [
    {
      id: 'a01',
      src: dirAudio + '0_Dusty.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page002_game0/img/audioOn.png', iconOff: 'games/page002_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 410,
        x: 0,
      },
      width: '50px',
      height: '50px',
      unit: 'px',
    },
    {
      id: 'a02',
      src: dirAudio + '3_Tom.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page002_game0/img/audioOn.png', iconOff: 'games/page002_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 300,
        x: 56,
      },
      width: '50px',
      height: '50px',
      unit: 'px',
    },
    {
      id: 'a03',
      src: dirAudio + '4_Lisa.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page002_game0/img/audioOn.png', iconOff: 'games/page002_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 260,
        x: 38,
      },
      width: '50px',
      height: '50px',
      unit: 'px',
    },
  ],
  cssStyle: {
    overflow: 'hidden',
  },
  configGame: configGame,
};

export default dataConfig;
